export const UPDATE_DOCUMENT_TEMPLATE = gql`
  mutation UPDATE_DOCUMENT_TEMPLATE($documentTemplateId: String!, $input: UpdateDocumentTemplateInput!) {
    updateDocumentTemplate(documentTemplateId: $documentTemplateId, input: $input) {
      documentTemplateId
      documentName
      documentCategory
      signers
      userStatus
    }
  }
`

export const GET_DOCUMENT_TEMPLATES = gql`
  query GET_DOCUMENT_TEMPLATES($searchTerm: String) {
    documentTemplates(searchTerm: $searchTerm) {
      documentTemplateId
      documentName
      signingToolRefId
      signers
      documentCategory
      userStatus
      status
    }
  }
`


export const GET_DOCUMENT_TEMPLATE = gql`
  query GET_DOCUMENT_TEMPLATE($documentTemplateId: String!) {
    documentTemplate(documentTemplateId: $documentTemplateId) {
      documentTemplateId
      documentName
    }
  }
`

export const DELETE_DOCUMENT_TEMPLATE = gql`
  mutation DELETE_DOCUMENT_TEMPLATE($documentTemplateId: String!) {
    deleteDocumentTemplate(documentTemplateId: $documentTemplateId) {
      documentTemplateId
    }
  }
`
